import { EnumSchema } from '../metadata-schema';

export const CohortstatusVanaf: EnumSchema = {
	"type": "string",
	"title": "CohortstatusVanaf",
	"enum": [
		"Nog bezig",
		"Tussentijds uitgestroomd",
		"Volledig cohort gevolgd"
	]
};
